const _RicosNodeStyle = class _RicosNodeStyle {
  constructor(nodeStyle) {
    this.getNodeStyle = () => this.nodeStyle;
    this.toCustomStyle = () => {
      return { paddingBottom: this.nodeStyle.paddingBottom, paddingTop: this.nodeStyle.paddingTop };
    };
    this.overrideWith = (nodeStyle = {}) => {
      return _RicosNodeStyle.of({ ...this.nodeStyle, ...nodeStyle });
    };
    this.nodeStyle = nodeStyle;
  }
  static of(nodeStyle) {
    return new _RicosNodeStyle(nodeStyle || {});
  }
};
_RicosNodeStyle.fromCustomStyle = (customStyle) => {
  const { paddingBottom, paddingTop } = customStyle;
  const nodeStyle = {
    paddingBottom,
    paddingTop
  };
  return _RicosNodeStyle.of(nodeStyle);
};
let RicosNodeStyle = _RicosNodeStyle;
export {
  RicosNodeStyle
};
//# sourceMappingURL=node-style.js.map
